export default function FirstViewCopy() {
  return (
    <section className="py-20 px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md hover:scale-[1.03] transition-all duration-250 ease-out">
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-[#F2A67E]/10 rounded-full flex items-center justify-center mb-4">
                <i className="ri-check-line text-[#F2A67E] text-2xl"></i>
              </div>
              <p className="text-[#5A4033] font-medium mb-3">
                何から始めればいいか分からない
              </p>
              <p className="text-[#5A4033] text-sm leading-relaxed">
                情報が多すぎて、<br />
                最初の一歩が見えなくなっていませんか。
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md hover:scale-[1.03] transition-all duration-250 ease-out">
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-[#F2A67E]/10 rounded-full flex items-center justify-center mb-4">
                <i className="ri-check-line text-[#F2A67E] text-2xl"></i>
              </div>
              <p className="text-[#5A4033] font-medium mb-3">
                どこで建てるか決められない
              </p>
              <p className="text-[#5A4033] text-sm leading-relaxed">
                何が違うのか分からず、<br />
                決め手が見えなくなっていませんか。
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md hover:scale-[1.03] transition-all duration-250 ease-out">
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-[#F2A67E]/10 rounded-full flex items-center justify-center mb-4">
                <i className="ri-check-line text-[#F2A67E] text-2xl"></i>
              </div>
              <p className="text-[#5A4033] font-medium mb-3">
                営業の言うことを信じていいか不安
              </p>
              <p className="text-[#5A4033] text-sm leading-relaxed">
                勧められるまま進んで、<br />
                後悔しないか不安になっていませんか。
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md hover:scale-[1.03] transition-all duration-250 ease-out">
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-[#F2A67E]/10 rounded-full flex items-center justify-center mb-4">
                <i className="ri-check-line text-[#F2A67E] text-2xl"></i>
              </div>
              <p className="text-[#5A4033] font-medium mb-3">
                住宅ローンが通るか心配
              </p>
              <p className="text-[#5A4033] text-sm leading-relaxed">
                借りられるかどうかも、<br />
                返していけるかも不安ではありませんか。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}